import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { RTMP_LIST_VOD } from 'src/constants/queryKeys';

export const networkGetRtmpList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`Rtmp/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchRtmpList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [RTMP_LIST_VOD, pageIndex, payload],
    queryFn: () => networkGetRtmpList(payload, pageIndex, pageSize),
  });
}

export const networkCreateRtmp = async (data) => {
  const res = await axiosInstance.post('Rtmp/Insert', data);
  return res;
};

export const networkUpdateRtmp = async (gameId, data) => {
  const res = await axiosInstance.post(`Rtmp/Update/${gameId}`, data);
  return res;
};

export const networkRemoveRtmp = async (gameId) => {
  const res = await axiosInstance.post(`Rtmp/Remove/${gameId}`);
  return res;
};

export const networkGetRtmpServerList = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`RtmpServer/List/${pageIndex}/${pageSize}`);
  return res;
};
